"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m22.794 19.666-4.962-6.32a.966.966 0 0 0-.65-.37.979.979 0 0 0-.72.21l-2.2 1.78-4.102-5.01 2.3-1.88c.42-.34.49-.97.15-1.39L7.64.376a.966.966 0 0 0-.65-.37.98.98 0 0 0-.72.21l-3.282 2.66c-.17.14-.29.33-.34.55l-1.62 7.12c-.07.3 0 .61.2.85l9.863 12.24c.19.23.46.36.76.36l6.913-.07c.22 0 .43-.08.6-.22l3.27-2.66a.995.995 0 0 0 .151-1.39l.01.01Zm-2.43.67-1.732 1.41c-.14.11-.39.2-.57.2l-5.412.05c-.18 0-.41-.11-.52-.25l-8.853-10.98a.748.748 0 0 1-.13-.56l1.3-5.69c.04-.17.18-.4.32-.51l1.691-1.37c.14-.11.34-.09.45.05l3.322 4.22c.11.14.09.34-.05.45l-1.04.85c-.14.11-.34.31-.45.45 0 0-.47.57-.52 1.1-.05.53.29 1.18.29 1.18.08.16.24.39.35.53l3.7 4.52c.11.14.32.33.46.44 0 0 .71.54 1.291.54.44 0 .98-.29.98-.29.15-.08.39-.24.53-.36l.89-.72a.32.32 0 0 1 .451.05l3.311 4.22c.11.14.09.34-.05.45l-.009.02Z"
  })]
});